import type { LancamentoFinanceiro } from '@hooks/useLancamentos.js'

export type TipoFiltro = 'todos' | 'gasto' | 'receita'
export type PeriodoFiltro = 'total' | 'mes' | 'trimestre'
export type TabId = 'lancamentos' | 'dashboard' | 'relatorios'
export type TipoLanc = 'gasto' | 'receita'

export type FormState = {
  tipo: TipoLanc
  titulo: string
  valor: string
  data: string
  categoria: string
  fornecedor: string
  formaPagamento: string
  status: string
  moduloId: string
  observacoes: string
}

export function emptyForm(tipo: TipoLanc = 'gasto'): FormState {
  return {
    tipo,
    titulo: '',
    valor: '',
    data: new Date().toISOString().slice(0, 10),
    categoria: '',
    fornecedor: '',
    formaPagamento: 'pix',
    status: tipo === 'receita' ? 'pago' : 'previsto',
    moduloId: '',
    observacoes: '',
  }
}

export type LancamentoItem = LancamentoFinanceiro & { id: number }

export const STATUS_VARIANT: Record<string, 'success' | 'warning' | 'danger' | 'default'> = {
  pago: 'success',
  previsto: 'default',
  pendente: 'warning',
  parcelado: 'warning',
}

export const STATUS_LABELS: Record<string, string> = {
  pago: 'Pago',
  previsto: 'Previsto',
  pendente: 'Pendente',
  parcelado: 'Parcelado',
}

export const CHART_COLORS = [
  '#E8A830',
  '#1B3A6B',
  '#28A745',
  '#3A5F94',
  '#A06A18',
  '#C68821',
  '#264A7E',
  '#156628',
  '#5C82B5',
  '#7A5717',
  '#D4A24C',
  '#6E6859',
  '#F2C757',
  '#DC3545',
  '#3B82F6',
]

export function getPeriodoStart(p: PeriodoFiltro): string | null {
  if (p === 'total') return null
  const d = new Date()
  if (p === 'mes') return new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10)
  d.setMonth(d.getMonth() - 3)
  return d.toISOString().slice(0, 10)
}
